import { configureStore } from '@reduxjs/toolkit';

import fetchReducer from './reducer/FetchDataReducer';

import sidebarReducer from './reducer/SidebarSlice';

import createSagaMiddleware from 'redux-saga';

//import logger from 'redux-logger'

import RootSaga from './saga/RootSaga';

let sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];

export const Store = configureStore({

  reducer: {

    FetchDataReducer: fetchReducer,

    sidebarReducer: sidebarReducer

  },

  middleware,

});

sagaMiddleware.run(RootSaga)


